module.exports = __webpack_public_path__ + "static/media/01.928c8071.mp4";